import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PlanTableStore {

}

export enum PlanTableStoreKeys {

}
